import moment from "moment";

/**
 *
 * @returns []
 */

export const getRangeTime = () => {
    let timeRange = [];
    const timeFrom = moment("2023-01-24T02:00:00.000Z");
    const timeTo = moment("2023-01-24T09:30:00.000Z");
    for (let time = timeFrom; time <= timeTo; time = moment(time).add(30, "m")) {
        let timeNext = moment(time).add(30, "m");
        timeRange.push({
            label: `${moment(time).format("HH:mm")} - ${moment(timeNext).format("HH:mm")}`,
            value: `${moment(time).format("HH:mm")} - ${moment(timeNext).format("HH:mm")}`,
            // value: `${moment(time).format()},${moment(timeNext).format()}`,
        });
    }
    return timeRange;
};
